// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1761 ? "d0deef33" : chunkId) + "." + {"1761":"71ee25f926b1aaa7","2579":"1eecdbd5aa7834b8"}[chunkId] + ".js";
};